import SprintIcon from '@images/icons/sprint.svg';
import TestingIcon from '@static/images/icons/testing-icon.svg';
import DesignIcon from '@static/images/icons/design-icon.svg';

import jsIcon from '@images/icons/technologies/js.svg';
import angularIcon from '@images/icons/technologies/angular.svg';
import htmlIcon from '@images/icons/technologies/html.svg';
import tsIcon from '@images/icons/technologies/ts.svg';
import reactIcon from '@images/icons/technologies/react.svg';
import pythonIcon from '@images/icons/technologies/python.svg';
import djangoIcon from '@images/icons/technologies/django.svg';
import flaskIcon from '@images/icons/technologies/flask.svg';
import postgreSqlIcon from '@images/icons/technologies/postgre-sql.svg';
import mongoDbIcon from '@images/icons/technologies/mongo-db.svg';

import kotlinIcon from '@images/icons/technologies/kotlin.svg';
import swiftIcon from '@images/icons/technologies/swift.svg';
import gpsIcon from '@images/icons/technologies/gps.svg';
import bleIcon from '@images/icons/technologies/ble.svg';
import ibeaconsIcon from '@images/icons/technologies/ibeacons.svg';
import reactNativeIcon from '@images/icons/technologies/react-native.svg';
import expoIcon from '@images/icons/technologies/expo.svg';

import { PageUrls } from '@utils/constants/PageUrls';

export const internalLinkingData = [
	{
		icon: SprintIcon,
		title: 'How we work?',
		items: ['Development Flow', 'Weekly Sprints', 'Communication'],
		link: PageUrls.HOW_WE_WORK,
	},
	{
		icon: DesignIcon,
		title: 'UX/UI design',
		items: [
			'Research',
			'Concept',
			'Software architecture',
			'UX design services',
		],
		link: PageUrls.DESIGN,
	},
	{
		icon: TestingIcon,
		title: 'Quality Assurance & Testing',
		items: ['Manual testing', 'Automated testing', 'Unit testing'],
		link: PageUrls.TESTING,
	},
];

export const webApplicationsData = [
	{
		name: 'Frontend',
		technologies: [
			{
				icon: jsIcon,
				name: 'JavaScript',
			},
			{
				icon: angularIcon,
				name: 'Angular',
			},
			{
				icon: htmlIcon,
				name: 'HTML5/CSS',
			},
			{
				icon: tsIcon,
				name: 'TypeScript',
			},
			{
				icon: reactIcon,
				name: 'React',
			},
		],
	},
	{
		name: 'Backend',
		technologies: [
			{
				icon: pythonIcon,
				name: 'Python',
			},
			{
				icon: djangoIcon,
				name: 'Django',
			},
			{
				icon: flaskIcon,
				name: 'Flask',
			},
			{
				icon: postgreSqlIcon,
				name: 'PostgreSQL',
			},
			{
				icon: mongoDbIcon,
				name: 'MongoDB',
			},
		],
	},
];

export const mobileApplicationsData = [
	{
		name: 'Native',
		technologies: [
			{
				icon: kotlinIcon,
				name: 'Kotlin',
			},
			{
				icon: swiftIcon,
				name: 'Swift',
			},
			{
				icon: gpsIcon,
				name: 'GPS',
			},
			{
				icon: bleIcon,
				name: 'BLE',
			},
			{
				icon: ibeaconsIcon,
				name: 'iBeacons',
			},
		],
	},
	{
		name: 'Cross-platform',
		technologies: [
			{
				icon: reactNativeIcon,
				name: 'React Native',
			},
			{
				icon: expoIcon,
				name: 'Expo',
			},
			{
				icon: gpsIcon,
				name: 'GPS',
			},
			{
				icon: bleIcon,
				name: 'BLE',
			},
			{
				icon: ibeaconsIcon,
				name: 'iBeacons',
			},
		],
	},
];
